import {
	nextTick
} from 'vue'
import vm from '../../main'
import {
	getDataCache,
	setDataCache
} from './api'
let timer = null
const set_storage_list = (type = 'id', arr = [], str = 'id') => {
	arr = filter_arr(arr, str)
	setDataCache(type,
		JSON.stringify(arr))
}
//数组去重  默认id
const filter_arr = (arr = [], str = 'id') => {
	let obj = {}
	return arr.filter((item) => {
		return obj.hasOwnProperty((typeof item) + item[str]) ? false : (obj[(typeof item) + item[str]] =
			true)
	})
}
//表格数据无数据加'/'
const table_filter = (arr = [], r_arr = [], r_str = '-') => {
	for (let item of arr) {
		for (let item1 of r_arr) {
			item[item1] = item[item1] ? item[item1] : r_str
		}
	}
	return arr
}
//日期转换格式  "yyyy-MM-dd hh:mm:ss"
const myFormater = (timeStr, fmt) => {
	let o = {
		"M+": new Date(timeStr).getMonth() + 1, //月份 
		"d+": new Date(timeStr).getDate(), //日 
		"h+": new Date(timeStr).getHours(), //小时 
		"m+": new Date(timeStr).getMinutes(), //分 
		"s+": new Date(timeStr).getSeconds(), //秒 
		"q+": Math.floor((new Date(timeStr).getMonth() + 3) / 3), //季度 
		"S": new Date(timeStr).getMilliseconds() //毫秒 
	};
	if (/(y+)/.test(fmt)) {
		fmt = fmt.replace(RegExp.$1, (new Date(timeStr).getFullYear() + "").substr(4 - RegExp.$1.length));
	}
	for (var k in o) {
		if (new RegExp("(" + k + ")").test(fmt)) {
			fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k])
				.length)));
		}
	}
	return fmt;
}
const scrollTopId = (traget, top = 0) => {
	nextTick(() => {
		const tragetElem = document.querySelector(traget);
		console.log('tragetElem', tragetElem.offsetTop);
		const tragetElemPostition = tragetElem.offsetTop - top;
		console.log('tragetElemPostition', tragetElemPostition);
		// 当前滚动高度
		let scrollTop =
			document.documentElement.scrollTop || document.body.scrollTop;
		// 滚动step方法
		const step = function() {
			// 距离目标滚动距离
			let distance = tragetElemPostition - scrollTop;
			// 目标需要滚动的距离，也就是只走全部距离的五分之一
			scrollTop = scrollTop + distance / 5;
			if (Math.abs(distance) < 1) {
				window.scrollTo(0, tragetElemPostition);
			} else {
				window.scrollTo(0, scrollTop);
				setTimeout(step, 20);
			}
		};
		step();
	});
};
const setAboutUser = (data) => {
	let expiration_time = VueCookie.get("loginTime")
	let expiresNum = 1
	if (expiration_time) {
		expiresNum = 30
	}
	vm.cookie.set("userInfo", JSON.stringify(data), {
		expires: expiresNum,
	});
}
const authorityCheck = (type = 1) => {
	// type:1  校验凌云卡
	let flag = false
	if (type == 1) {
		if (vm.cookie.get("token")) {
			let userInfo = vm.cookie.get("userInfo") ?
				JSON.parse(vm.cookie.get("userInfo")) : {};
			if (!userInfo.isVIP) {
				vm.$vipModal();
				flag = true
			}
		}
	}
	return flag
}
const getRefreshToken = () => {
	let loginInfo = vm.cookie.get('loginInfo') ? JSON.parse(vm.cookie.get('loginInfo')) : {};

	vm.$request({
		api: "plan",
		url: "Login/RefreshToken",
		method: 'post',
		headers: {
			RefreshToken: loginInfo.refresh_token
		}
	}).then(res => {
		let {
			data
		} = res
		let {
			access_token,
			expiration
		} = data
		// vm.cookie.set('token', access_token)
		let expiration_time = vm.cookie.get("loginTime")
		console.log(expiration_time, "loginTime")
		let expiresNum = 1
		if (expiration_time) {
			expiresNum = 30
		}
		console.log(expiresNum, "expiresNum")
		setLoginExpiration(data, expiresNum)
	})
}
const setLoginExpiration = (data, expiresNum) => {
	let loginInfo = {
		access_token: data.access_token,
		expiration: data.expiration,
		refresh_token: data.refresh_token,
	}
	// let cur_time = new Date().getTime()
	// let expiration_time = new Date(data.expiration).getTime()
	// let subtract_time = parseInt((expiration_time - cur_time) / 1000)
	// subtract_time = subtract_time - 60 >= 0 ? subtract_time - 60 : 0
	// console.log('subtract_time', subtract_time);
	// clearTimeout(timer)
	// timer = setTimeout(() => {
	// 	getRefreshToken()
	// }, subtract_time * 1000)
	let cur_time = new Date().getTime()
	let expiration_time = vm.cookie.get("loginTime")
	if (expiration_time) {
		vm.cookie.set("loginTime", cur_time, {
			expires: expiresNum,
		});
	}
	vm.cookie.set("loginInfo", JSON.stringify(loginInfo), {
		expires: expiresNum,
	});
	vm.cookie.set("token", data.access_token, {
		expires: expiresNum,
	});
	vm.cookie.set("userInfo", JSON.stringify(data.userInfo), {
		expires: expiresNum,
	});
}
const operateAboutLogin = (data, expiresNum) => {
	setLoginExpiration(data, expiresNum)
	getDataCache()
}
const getDataCacheLocal = async (key, norequest) => {
	let userInfo = JSON.parse(vm.cookie.get("userInfo")) || {
		province: vm.cookie.get("city")
	}
	if (norequest) {
		return localStorage.getItem(`${userInfo.province}~${key}`);
	}
	await getDataCache()
	return localStorage.getItem(`${userInfo.province}~${key}`)
}
const removeDataCacheLocal = (key) => {
	let userInfo = JSON.parse(vm.cookie.get("userInfo")) || {
		province: vm.cookie.get("city")
	}
	localStorage.removeItem(`${userInfo.province}~${key}`)
}


export default {
	set_storage_list,
	filter_arr,
	myFormater,
	table_filter,
	scrollTopId,
	setAboutUser,
	authorityCheck,
	getRefreshToken,
	setLoginExpiration,
	operateAboutLogin,
	getDataCacheLocal,
	removeDataCacheLocal,
}
